import { useState } from 'react';
import { toast } from 'sonner';
import { Lock, Eye, EyeOff, CheckCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const SettingsModule = ({ token }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) { toast.error('Les mots de passe ne correspondent pas'); return; }
    if (newPassword.length < 8) { toast.error('Minimum 8 caracteres'); return; }
    setLoading(true);
    try {
      const res = await fetch(API + '/auth/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ currentPassword, newPassword })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur');
      setSuccess(true);
      setCurrentPassword(''); setNewPassword(''); setConfirmPassword('');
      toast.success('Mot de passe change avec succes');
    } catch (err) {
      toast.error(err.message || 'Erreur');
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto space-y-6 animate-fade-in">
      <div className="grid-card p-6 border-l-2 border-l-[#DC143C]">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-[#DC143C]/10 border border-[#DC143C]/50">
            <Lock className="w-5 h-5 text-[#DC143C]" />
          </div>
          <div>
            <h2 className="font-heading text-lg font-bold text-[#EDEDED] uppercase tracking-wider">CHANGER MOT DE PASSE</h2>
          </div>
        </div>
        {success && (
          <div className="flex items-center gap-2 p-3 bg-[#00FF9D]/10 border border-[#00FF9D]/30 mb-4">
            <CheckCircle className="w-4 h-4 text-[#00FF9D]" />
            <span className="font-mono text-xs text-[#00FF9D]">MOT DE PASSE MIS A JOUR</span>
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="font-mono text-[10px] text-[#888888] uppercase tracking-widest block mb-2">MOT DE PASSE ACTUEL</label>
            <div className="relative">
              <input type={showCurrent ? 'text' : 'password'} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required
                className="w-full bg-[#0A0A0A] border border-white/10 p-3 pr-10 font-mono text-xs text-white focus:outline-none focus:border-[#DC143C]/50"
                placeholder="••••••••" />
              <button type="button" onClick={() => setShowCurrent(!showCurrent)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#888888]">
                {showCurrent ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <div>
            <label className="font-mono text-[10px] text-[#888888] uppercase tracking-widest block mb-2">NOUVEAU MOT DE PASSE</label>
            <div className="relative">
              <input type={showNew ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)} required minLength={8}
                className="w-full bg-[#0A0A0A] border border-white/10 p-3 pr-10 font-mono text-xs text-white focus:outline-none focus:border-[#DC143C]/50"
                placeholder="••••••••" />
              <button type="button" onClick={() => setShowNew(!showNew)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#888888]">
                {showNew ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <div>
            <label className="font-mono text-[10px] text-[#888888] uppercase tracking-widest block mb-2">CONFIRMER NOUVEAU MOT DE PASSE</label>
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required
              className="w-full bg-[#0A0A0A] border border-white/10 p-3 font-mono text-xs text-white focus:outline-none focus:border-[#DC143C]/50"
              placeholder="••••••••" />
            {confirmPassword.length > 0 && newPassword !== confirmPassword && (
              <p className="font-mono text-[10px] text-[#DC143C] mt-1">Les mots de passe ne correspondent pas</p>
            )}
          </div>
          <button type="submit" disabled={loading || !currentPassword || !newPassword || newPassword !== confirmPassword}
            className="w-full py-3 bg-[#DC143C] text-white font-heading text-xs uppercase tracking-widest hover:bg-[#FF2E55] transition-colors disabled:opacity-30">
            {loading ? 'MISE A JOUR...' : 'CONFIRMER LE CHANGEMENT'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SettingsModule;